import { apiClient } from './client';
// ============================================================================
// API CLIENT
// ============================================================================
export const workflowSettingsApi = {
    // ---------- WORKSPACE LEVEL ----------
    /** Get workflow settings for a workspace */
    getWorkspaceSettings: (clientCompanyId, workspaceId) => apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/WorkflowSettings`),
    /** Create or update workflow settings for a workspace */
    updateWorkspaceSettings: (clientCompanyId, workspaceId, settings) => apiClient.put(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/WorkflowSettings`, settings),
    // ---------- CAMPAIGN LEVEL ----------
    /** Get workflow settings for a campaign */
    getCampaignSettings: (clientCompanyId, workspaceId, campaignId) => apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/Campaigns/${campaignId}/WorkflowSettings`),
    /** Create or update workflow settings for a campaign */
    updateCampaignSettings: (clientCompanyId, workspaceId, campaignId, settings) => apiClient.put(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/Campaigns/${campaignId}/WorkflowSettings`, settings),
    // ---------- WEB LEVEL ----------
    /** Get workflow settings for a specific web */
    getWebSettings: (clientCompanyId, workspaceId, webId) => apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/Webs/${webId}/WorkflowSettings`),
    /** Create or update workflow settings for a web */
    updateWebSettings: (clientCompanyId, workspaceId, webId, settings) => apiClient.put(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/Webs/${webId}/WorkflowSettings`, settings),
    // ---------- EFFECTIVE (RESOLVED) SETTINGS ----------
    /** Get the effective/resolved workflow settings for a web (walks up the inheritance chain) */
    getEffectiveWebSettings: (clientCompanyId, workspaceId, campaignId, webId) => apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/Campaigns/${campaignId}/Webs/${webId}/WorkflowSettings/Effective`),
    // ---------- USER SEARCH ----------
    /**
     * Search for eligible users (for reviewer or internal team assignment)
     * @param workspaceId - Workspace ID
     * @param clientCompanyId - Client company ID
     * @param searchTerm - Search term (name, email, etc.)
     * @param userType - Type of user ("reviewer" or "internal")
     */
    searchEligibleUsers: (workspaceId, clientCompanyId, searchTerm, userType) => apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/EligibleUsers?searchTerm=${encodeURIComponent(searchTerm)}&userType=${encodeURIComponent(userType)}`),
};
// ============================================================================
// CLIENT-SIDE SETTINGS RESOLUTION
// ============================================================================
/**
 * Resolves effective settings for a web by walking up the inheritance chain.
 * Temporary fallback until the backend /Effective endpoint is available.
 * Tries: Web → Campaign → Workspace
 */
export async function resolveEffectiveSettings(clientCompanyId, workspaceId, campaignId, webId) {
    // Try the backend Effective endpoint first
    const effectiveRes = await workflowSettingsApi.getEffectiveWebSettings(clientCompanyId, workspaceId, campaignId, webId);
    if (effectiveRes.data)
        return effectiveRes;
    // Fallback: walk the chain client-side
    const webRes = await workflowSettingsApi.getWebSettings(clientCompanyId, workspaceId, webId);
    if (webRes.data && !webRes.data.InheritFromParent)
        return webRes;
    const campaignRes = await workflowSettingsApi.getCampaignSettings(clientCompanyId, workspaceId, campaignId);
    if (campaignRes.data && !campaignRes.data.InheritFromParent)
        return campaignRes;
    return workflowSettingsApi.getWorkspaceSettings(clientCompanyId, workspaceId);
}
